import { createEntityQueryKeys } from '@/shared/lib'

export const userNoteKeys = createEntityQueryKeys(['user-notes'])
